module.exports = __webpack_public_path__ + "static/header-logo-13cd893d91056524026d36e9b2b85064.png";